import './MissionCards.css'
const MissionCards = (props) => {
  return (
    <div className="mission-card">
      <div className="mission-num">{props.number}</div>
      <h5>{props.title}</h5>
      <p>{props.desc}</p>
    </div>
  )
}
export default MissionCards


